import React from 'react'
import styled from 'styled-components';
import { useTranslation } from 'react-i18next'
import perksIcons from './assets/icons.js'

const Index = () => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      {t('root.perks', {returnObjects: true}).map(({title, text, iconKey}, index) => 
        <Article key={index}>
          <BlurbImage alt={`${title} Icon`} src={perksIcons[iconKey]} loading="lazy"/>
          <BlurbHeader>{title}</BlurbHeader>
          <BlurbText>{text}</BlurbText>
        </Article>
      )}
    </Wrapper>
  )
}

export default Index

const Wrapper = styled.section`
  display: grid;
  justify-items: center;
  grid-template-columns: 1fr;
  gap: 16px;
  max-width: 1200px; /* Adjust as needed */
  margin: auto;
  @media ${props => props.theme.tabletUp} {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 32px;
  }
`;

const Article = styled.article`
  margin: 20px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const BlurbImage = styled.img`
  width: 200px;
  height: 200px;
`;

const BlurbHeader = styled.h2`
  margin: 20px 0;
  text-align: center;
  font-size: 1.5em;
`;

const BlurbText = styled.p`
  text-align: center;
`;